import { Link } from 'react-router-dom';
import type { ComponentType, SVGProps } from 'react';

interface IconButtonProps {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  onClick?: () => void;
  to?: string;
  variant?: 'ghost' | 'danger-ghost';
  disabled?: boolean;
  hidden?: boolean;
}

export function IconButton({
  icon: Icon,
  label,
  onClick,
  to,
  variant = 'ghost',
  disabled,
  hidden,
}: IconButtonProps) {
  if (hidden) return null;

  const className = `btn icon-btn btn-${variant}`;

  if (to) {
    return (
      <Link className={className} to={to} title={label} aria-label={label}>
        <Icon className="icon-btn-svg" />
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      title={label}
      aria-label={label}
      disabled={disabled}
    >
      <Icon className="icon-btn-svg" />
    </button>
  );
}
